import type { CheckInBadgeStatus } from '@/features/marquee/utils'
import { cn } from '@/helpers/utils'
import { type TKey, useTranslation } from '@/translations/i18n'

const STATUS_CONFIG: Record<
	CheckInBadgeStatus,
	{ label: TKey; className: string }
> = {
	arrived: {
		label: 'marquee:checkin_status_arrived',
		className: 'bg-success-100 text-success-700'
	},
	no_host_id: {
		label: 'marquee:checkin_status_no_host_id',
		className: 'bg-orange-600/10 text-orange-700'
	},
	no_show: {
		label: 'marquee:checkin_status_no_show',
		className: 'bg-grey-200 text-grey-1000'
	},
	waiting: {
		label: 'marquee:checkin_status_waiting_host',
		className: 'bg-grey-200 text-grey-1000'
	}
}

interface CheckInStatusBadgeProps {
	status: CheckInBadgeStatus
	className?: string
}

export function CheckInStatusBadge({
	status,
	className
}: CheckInStatusBadgeProps) {
	const { t } = useTranslation()
	const { label, className: toneClass } = STATUS_CONFIG[status]

	return (
		<span
			className={cn(
				'inline-flex items-center whitespace-nowrap rounded-full px-3 py-1.5 font-medium text-xs',
				toneClass,
				className
			)}
		>
			{t(label)}
		</span>
	)
}
